import { render, staticRenderFns } from "./page-accordion.vue?vue&type=template&id=4c4340c2"
import script from "./page-accordion.vue?vue&type=script&lang=js"
export * from "./page-accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports